export default {
  namespaced: true,
  state: () => ({
    enableClientQuantity: true,
    failConfirmation: "<p>Foute betaling.</p>",
    failMailFeedback: null,
    failOrderflowFeedback: null,
    ignoreMandatoryProducts: true,
    introduction: "<p>Welkom</p>",
    skipMailConfirmation: false,
    skipPayment: false,
    successConfirmation: "Success",
    header: "",// leave empty to show title
    title: "Orderflow Webshop",
    disabled: false,
    disabledMessage: "<p>De webshop is gesloten.</p>",
    discount: 0,
  }),
  mutations: {
    setWebshop: (state, payload) => {
      for (const prop in payload) {
        if (typeof payload[prop] !== "undefined") {
          state[prop] = payload[prop];
        }
      }
    },
  },
};
